import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FourOhFourComponent } from './four-oh-four/four-oh-four.component';
import { FourOhFourRoutingModule } from './four-oh-four-routing.module';
import { LoadingComponent } from './loading/loading.component';



@NgModule({
  declarations: [FourOhFourComponent, LoadingComponent],
  imports: [
    CommonModule,
    FourOhFourRoutingModule
  ]
})
export class FourOhFourModule { }
